import { getApiUrl } from '../../config/development';
import AsyncStorage from '@react-native-async-storage/async-storage';

export const loginAdmin = async (email, password) => {
  const url = `${getApiUrl()}/admin/auth/login`;
  const requestBody = {
    email,
    password,
  };

  console.log('Attempting admin login:', {
    url,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' }
  });

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    let data;
    const textResponse = await response.text();
    try {
      data = JSON.parse(textResponse);
    } catch (e) {
      console.error('Failed to parse response:', textResponse);
      throw new Error('Invalid server response');
    }

    if (!response.ok) {
      console.error('Server response:', {
        status: response.status,
        statusText: response.statusText,
        data: data
      });
      throw new Error(data.message || data.error || 'Login failed');
    }

    // Store authentication data
    await AsyncStorage.setItem('adminAuthToken', data.token);
    await AsyncStorage.setItem('adminUser', JSON.stringify(data.user));

    return {
      token: data.token,
      admin: data.user
    };
  } catch (error) {
    console.error('Admin login error:', error);
    throw error;
  }
};

export const logoutAdmin = async () => {
  try {
    // Clear admin auth data
    await AsyncStorage.multiRemove(['adminAuthToken', 'adminUser']);
    return { success: true };
  } catch (error) {
    console.error('Admin logout error:', error);
    throw error;
  }
};
